import React, { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";

import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import { Autoplay, Pagination, Navigation } from "swiper/modules";

import picture1 from "./Images/picture1.png";
import picture2 from "./Images/picture2.png";
import picture3 from "./Images/picture3.png";
import "./css/Secure.css";

export const Secure = () => {
  const [isGrabbing, setIsGrabbing] = useState(false);

  const handleMouseDown = (e) => {
    if (e.button === 0 || e.button === 2) {
      setIsGrabbing(true);
      e.target.closest(".swiper-slide").classList.add("grab");
    }
  };

  const handleMouseUp = (e) => {
    if (e.button === 0 || e.button === 2) {
      setIsGrabbing(false);
      e.target.closest(".swiper-slide").classList.remove("grab");
    }
  };

  const handleMouseLeave = (e) => {
    setIsGrabbing(false);
    e.target.closest(".swiper-slide").classList.remove("grabbing");
  };
  const swiperSlides = [
    {
      title: "Term 24 Months",
      description:
        "Invest 1 to 5 lakh and get pension of 1,000 to 5,000 per month",
      image: picture1,
    },
    {
      title: "Tenure 60 Months",
      description:
        "Invest 1 to 5 lakh and get pension of 1,000 to 5,000 per month",
      image: picture2,
    },
    {
      rate: "7.50%",
      duration: "90 to 180 days",
      image: picture3,
    },
    {
      rate: "8.50%",
      duration: "181 to 270 days",
      image: picture1,
    },
    {
      rate: "9.75%",
      duration: "271 to 365 days",
      image: picture1,
    },
    {
      rate: "10.85%",
      duration: "365 to 25 months",
      image: picture1,
    },
    {
      rate: "12%",
      duration: "26 to 60 months",
      image: picture2,
    },
  ];

  return (
    <div className="mains secures">
      <div className="secure-t1">
        <br />
        <h3>Secure Your Future with Our Mega Deposit Package</h3>
      </div>
      <div className="secure-st1">
        <p>
          Unlock Growth and Financial Stability with Our Mega
          <br />
          Deposit Package - Your Path to Prosperity!
        </p>
      </div>
      <div className="secure">
        <Swiper
          slidesPerView={1}
          spaceBetween={10}
          pagination={{
            dynamicBullets: true,
          }}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          // loop={true}
          navigation={true}
          breakpoints={{
            640: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 50,
            },
          }}
          modules={[Autoplay, Pagination, Navigation]}
          className="mySwiper"
        >
          {swiperSlides.map((slide, index) => (
            <SwiperSlide
              key={index}
              className={isGrabbing ? "grabbing" : "grab"}
              onMouseDown={handleMouseDown}
              onMouseUp={handleMouseUp}
              onMouseLeave={handleMouseLeave}
            >
              <Card sx={{ maxWidth: 450, height: 350, width: "100%" }}>
                <CardContent>
                  {slide.title && (
                    <Typography gutterBottom variant="h5" component="div">
                      {slide.title}
                    </Typography>
                  )}
                  {slide.description && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      className="text-left"
                    >
                      {slide.description}
                    </Typography>
                  )}
                  {slide.rate && (
                    <Typography
                      gutterBottom
                      variant="h5"
                      component="div"
                      className="!mb-3"
                    >
                      <p>{slide.rate}</p>
                    </Typography>
                  )}
                  {slide.duration && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      className="!mb-4"
                    >
                      {slide.duration}
                    </Typography>
                  )}
                </CardContent>
                <CardMedia
                  sx={{ height: 140, paddingTop: "100%" }}
                  image={slide.image}
                  title="green iguana"
                />
              </Card>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
